export default "__VITE_ASSET__04912453__"